export default __webpack_public_path__ + "static/foundations-carousel-panel1-e3a86f74afd7f69f9e5b79045e420120cd417909faab7834c314cc6a2d8a08b7.png";